
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"17","height":"17","fill":"#D0DBDB","rx":"1"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M4.5 6.5v1m8 2v1m-11-6.75s3.096 1.347 7-.014 7 .014 7 .014v9.527s-3.096-1.374-7-.013c-3.904 1.36-7 .013-7 .013zm9 4.75c0 1.38-.895 2.5-2 2.5s-2-1.12-2-2.5.895-2.5 2-2.5 2 1.12 2 2.5"}})])
          )
        }
      }
    